import { get } from 'lodash'
import { makeAutoObservable, runInAction} from 'mobx'
import StoreReferralCart from './StoreReferralCart'
import StoreReferralFormat from './StoreReferralFormat'


class StoreReferralProducts {
    products = []
    defaultProducts = []

    isShowProducts = false

    isInit = false

    productVariations = {}
    variantCombinationSelected = {}
    productVariantMapping = {}
    productVariationOrder = []

    currentProduct = null

    Init(data) {
        const productList = get(data, 'productList.items')

        if (!productList) return
        
        runInAction(() => {
            this.products = productList
            const itemDefault = data.productList.defaultItem
            itemDefault.qty = 1
            // StoreReferralCart.items = [itemDefault]
            StoreReferralFormat.paymentOptionSelected = data?.purchaseOptionDefault

            this.productVariations = data.productVariationSettings
            this.InitVariantCombinationSelected(data.productVariationSettings)

            this.productVariantMapping = data.productVariantMapping

            this.productVariationOrder = data.productVariationOrder

            this.isInit = true
        })
    }

    GetIsInit() {
        return this.isInit
    }

    GetProducts() {
        return this.products
    }

    SetProducts(products) {
        this.products = products
    }

    SetShowProducts(value) {
        this.isShowProducts = value
    }

    SetVariantCombinationSelected(variantCombination) {
        this.variantCombinationSelected = {
            ...this.variantCombinationSelected,
            ...variantCombination
        }
    }

    GetProductVariationOptions() {
        return Object.keys(this.productVariations)
    }

    GetProductVariationOrder() {
        return this.productVariationOrder
    }

    GetProductVariationData(variant) {
        return this.productVariations[variant]
    }

    InitVariantCombinationSelected(data) {
        Object.keys(data).forEach(variant => {
            const firstVariantItem = data[variant].items[0]

            this.SetVariantCombinationSelected({
                [variant]: firstVariantItem.value
            })
        })
    }

    ResetVariantCombinationSelected() {
        this.variantCombinationSelected = {}
    }


    GetVariantCombinationSelectedData() {

        try {
            const rawProducts = this.GetProducts()

            const variantCombinationItemCode = this.productVariantMapping.find(product => {
                const variants = product.variants

                return Object.keys(variants).every(variant => {
                    return variants[variant] === this.variantCombinationSelected[variant]
                })
            })


            if (!variantCombinationItemCode) {
                return {
                    product: null,
                    price: 0,
                    fromPrice: 0,
                    qtyItemInCart: 1,
                    isOutOfStock: false,
                    isError: true
                }
            }

            const product = rawProducts.find(product => product.id === variantCombinationItemCode.product_list_id)

            const cartItem = StoreReferralCart.items.find(item => item.id === variantCombinationItemCode.product_list_id)

            const result = {
                product,
                price: 0,
                fromPrice: 0,
                qtyItemInCart: cartItem?.qty || 1,
            }

            if (product) {
                this.currentProduct = product
                
                const isMember = StoreReferralCart.hasDiscount()
                const purchaseOption = StoreReferralFormat.paymentOptionSelected

                const productSelected = product.options[purchaseOption]

                const isOutOfStock = productSelected.qty === 0 || !!productSelected.system_tags.find(tag => tag.name === 'out_of_stock')

                result.isOutOfStock = isOutOfStock

                if (isMember) {

                    result.price = product.options[purchaseOption].price.member
                    result.fromPrice = product.options[purchaseOption].price.retail
                } else {
                    result.price = product.options[purchaseOption].price.retail
                    result.fromPrice = product.options[purchaseOption].price.retail
                }
            }

            return result
        } catch (error) {
            console.log('GetVariantCombinationSelectedData error', error)
            return {
                product: null,
                price: 0,
                fromPrice: 0,
                qtyItemInCart: 1,
                isOutOfStock: false,
                isError: true
            }
        }

    }

    constructor() {
        makeAutoObservable(this)
    }
}

export default new StoreReferralProducts()
